import {BaseRepository} from '../repositories/BaseRepository';

export class DeveloperPageComponent {
  container = null;

  repository = null;

  forms = [];

  location;

  constructor() {
    this.container = document.querySelector('body.page-id-2861');
    if (!this.container) {
      return;
    }

    this.location = window.location;

    this.repository = new BaseRepository();

    this.config = typeof DEV_PAGE_REGISTRATION_CONFIG === 'undefined' ? {} : DEV_PAGE_REGISTRATION_CONFIG;

    this.forms = [];

    this.initHsForms();

    this.openModal();
  }

  initHsForms() {
    setTimeout(() => {
      this.forms = this.container.querySelectorAll('.hbspt-form form');
      if (!this.forms.length) {
        return;
      }

      this.forms.forEach((form) => {
        form.addEventListener('submit', (e) => this.hsFormSubmitHandler(e));
      });

      this.openModal();
    }, 1000);
  }

  hsFormSubmitHandler(e) {
    e.preventDefault();

    const target = e.target;
    if (!target) {
      return;
    }

    this.sendRegistrationData(target);
  }

  async sendRegistrationData(form) {
    if (!this.repository) {
      return;
    }

    const data = new FormData(form);
    data.set('action', this.config.hasOwnProperty('action') ? this.config.action : '');
    data.set('_security_token', this.config.hasOwnProperty('nonce') ? this.config.nonce : '');

    const response = await this.repository.postWithFormData(data);
  }

  openModal() {
    if (this.location.href.search('developer#try') === -1) {
      return;
    }

    const button = document.querySelector('.see-it-in-action-btn .uael-trigger');
    if (button) {
      const mouseEvent = document.createEvent('MouseEvent');
      mouseEvent.initMouseEvent(
        'click', true, true, window, 0,
        0, 0, 0, 0,
        false, false, false, false,
        0, null
        );
      button.dispatchEvent(mouseEvent);
    }
  }
}